import React, { FC, useMemo } from "react";
import { useSelector } from "react-redux";

import { useConstructionExtensions } from "@/hooks";
import { ExtensionType } from "@/models/constructionExtensions";
import { RootState } from "@/reducers/types";
import { MachineIcon } from "@/sx-layout/common/MachineIcon";
import { Machine, MachineStatus } from "@/sx-layout/components/plotmap/models";
import { MachineType } from "@/sx-layout/components/settings/machineSetting/models";
import { useTerm } from "@/sx-layout/hooks";
import { getCurrentTimeInMinutes, normalizeHexColor, timeStringToMinutes } from "@/sx-layout/utils";

type Props = {
  id: string;
  machine: Machine;
  style: React.CSSProperties;
};

export const MachineObjectReadonly: FC<Props> = ({ machine, ...props }) => {
  const machineTypes = useSelector<RootState, MachineType[]>((state) => state.machine.machineTypes);
  const convertMachineTypeToIcon = (machine_type_id: number) => {
    const machineType = machineTypes.find((mt) => mt.machine_type_id === machine_type_id);

    return machineType ? machineType.machine_icon_id : null;
  };

  const layoutDate = useSelector<RootState, Date>((state) => state.plotmap.layoutDate);
  const { isToday } = useTerm(layoutDate);
  const { extension: objectTransparentExtension } = useConstructionExtensions(ExtensionType.PLOTMAP_OBJECT_TRANSPARENT);
  const isOutsideUseHours = useMemo(() => {
    if (!isToday || !objectTransparentExtension) return false;

    const now = getCurrentTimeInMinutes();
    const start = timeStringToMinutes(machine.use_start_hour);
    const end = timeStringToMinutes(machine.use_end_hour);

    return now < start || end < now;
  }, [objectTransparentExtension, isToday, machine.use_start_hour, machine.use_end_hour]);

  return (
    <div {...props} className="relative" style={{ ...props.style, opacity: isOutsideUseHours ? 0.3 : 1 }}>
      {/* アイコン */}
      <div id={`machine-object-${machine.machine_id}`}>
        <MachineIcon
          active={machine.status !== MachineStatus.STAND_BY}
          shapeColor={normalizeHexColor(machine.color)}
          machineIconId={convertMachineTypeToIcon(machine.machine_type_id)}
          selected={false}
        />
      </div>
    </div>
  );
};
